export default expireTime => {
  const now = new Date();

  return typeof expireTime === "undefined" || now.getTime() >= expireTime;
};
